import { Control, Controller } from 'react-hook-form';
import { CreateProductFormSchemaType } from '../common';
import i18n from 'i18n';
import { FormLabel } from '../form-label';
import LOCALS from 'commons/locals';
import { Input } from 'antd';

const ProductStampRemark = ({
  control,
}: {
  control: Control<CreateProductFormSchemaType>;
}) => {
  return (
    <div className="flex items-center gap-2">
      <FormLabel>{i18n.t(LOCALS.stamp_remark)}:</FormLabel>
      <Controller
        name="stampRemark"
        control={control}
        render={({ field }) => (
          <Input.TextArea
            {...field}
            className="w-full"
            placeholder={i18n.t(LOCALS.please_enter) || ''}
          />
        )}
      />
    </div>
  );
};

export default ProductStampRemark;
